// eslint-disable-next-line no-restricted-imports
import { useTheme } from '@emotion/react';
// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { effects } from '@iheartjane/reefer';
import { useSelector } from 'react-redux';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import exclamationIcon from '@jane/shared/assets/icons/exclamation.svg';

import { selectNotifications } from '../../customer/redux/notifications';
import { useHideNotifications } from './useHideNotifications';

interface NotificationContainerProps {
  notificationColor: string;
}

const NotificationContainer = styled.div<NotificationContainerProps>(
  ({ theme }) => ({
    display: 'flex',
    position: 'fixed',
    top: '15px',
    right: '25px',
    width: '240px',
    transition: 'all 0.5s ease-in-out',
    borderRadius: '6px',
    fontSize: '13px',
    lineHeight: '1.3m',
    boxShadow: `0 1px 5px 0 ${effects.lighten('#000', 0.5)}`,
    zIndex: 'var(--layers-toast)',
    color: theme.colors.grays.white,
  }),
  ({ notificationColor }) => ({
    backgroundColor: notificationColor,
  })
);

const NotificationInner = styled.div({
  display: 'flex',
  alignItems: 'center',
  padding: '11px 10px',
});

const NotificationsExclamation = styled.div({
  width: '36px',
  height: '36px',
  marginRight: '12px',
  backgroundImage: `url("${exclamationIcon}")`,
});

const NotificationsText = styled.div({
  flex: 1,
});

export const ServerNotifications = () => {
  const hideNotifications = useHideNotifications();

  const theme = useTheme();
  const { notificationOptions, notificationShown } =
    useSelector(selectNotifications);

  const { type, messages } = notificationOptions;
  const notificationColor =
    type === 'error'
      ? theme.colors.system.negative.main
      : theme.colors.system.positive.main;

  if (!notificationShown || !messages || hideNotifications) return null;

  return (
    <TransitionGroup>
      {messages.map((message, index) => (
        <CSSTransition key={index} classNames="notifications" timeout={500}>
          <NotificationContainer
            aria-live="polite"
            key={index}
            notificationColor={notificationColor}
          >
            <NotificationInner>
              <NotificationsExclamation />
              <NotificationsText>{message}</NotificationsText>
            </NotificationInner>
          </NotificationContainer>
        </CSSTransition>
      ))}
    </TransitionGroup>
  );
};
